<script>
  import { onMount } from 'svelte';
  import { initStatuses } from './statuses.js';
  import Matrix from './Matrix.svelte';
  import RelationshipSelect from './RelationshipSelect.svelte';
  import RelationshipPopup from './RelationshipPopup.svelte';
  import CharacterPopup from './CharacterPopup.svelte';
  import Legend from './Legend.svelte';
  import Intro from './Intro.svelte';
  import Title from './Title.svelte';

  let popupRelationship = {};
  let popupCharacter = {};
  let currentCharacter = {};
  let currentRelationship = {};
  let showIntro = true;
  
  const handleRelationshipPopup = (event) => {
    showIntro = false;
    popupCharacter = {};
    if (Object.keys(popupRelationship).length) {
      popupRelationship = {};
      window.setTimeout(() => {
        popupRelationship = event.detail;
      }, 150);
    }
    else {
      popupRelationship = event.detail;
    }
    currentCharacter = {};
    currentRelationship = event.detail;
  }

  const handleCharacterPopup = (event) => {
    showIntro = false;
    popupRelationship = {};
    if (Object.keys(popupCharacter).length) {
      popupCharacter = {};
      window.setTimeout(() => {
        popupCharacter = event.detail;
      }, 150);
    }
    else {
      popupCharacter = event.detail;
    }
    currentRelationship = {};
    currentCharacter = event.detail;
  }

  const reset = () => {
    popupRelationship = {};
    currentRelationship = {};
    popupCharacter = {};
    currentCharacter = {};
  }

  let status_init;
  onMount(async () => {
    status_init = initStatuses();
  });
</script>

<style global>
    @font-face {
      font-family: "helvetica-neue-lt-arabic";
      src: url("../fonts/helvetica-neue-lt-arabic.woff2") format("woff2"), url("../fonts/helvetica-neue-lt-arabic.woff") format("woff");
      font-style:normal; font-weight:400;
    }
    @font-face {
      font-family: "helvetica-neue-lt-arabic";
      src: url("../fonts/helvetica-neue-lt-arabic-45-light.woff2") format("woff2"), url("../fonts/helvetica-neue-lt-arabic-45-light.woff") format("woff");
      font-style:normal; font-weight:300;
    }
    @font-face {
      font-family: "helvetica-neue-lt-arabic";
      src: url("../fonts/helvetica-neue-lt-arabic-75-bold.woff2") format("woff2"), url("../fonts/helvetica-neue-lt-arabic-75-bold.woff") format("woff");
      font-style:normal; font-weight:700;
    }

    /** Font overrides **/
    html[lang="ar"] .font-sans,
    html[lang="ar"] .font-serif,
    html[lang="ar"] .font-sans_alt {
      font-family: 'helvetica-neue-lt-arabic' !important;
    }
    html[lang="ar"] .font-heading {
      font-family: 'helvetica-neue-lt-arabic', serif !important;
    }
    html[lang="ar"] .italic {
      font-style: normal !important;
    }

  body {
    color: #333;
    margin: 0;
    box-sizing: border-box;
    font-family: 'helvetica-neue-lt-arabic', sans-serif;
    font-size: 14px;
    line-height: 1.6;
  }

  a {
    color: rgb(0,100,200);
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  a:visited {
    color: rgb(0,80,160);
  }

  label, .label {
    font-family: 'helvetica-neue-lt-arabic', sans-serif;
    text-transform: uppercase;
    line-height: 1.2;
  }

  label {
    display: block;
  }

  input, button, select, textarea {
    font-family: inherit;
    font-size: inherit;
    padding: 0.4em;
    margin: 0 0 0.5em 0;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 2px;
  }

  input:disabled {
    color: #ccc;
  }

  input[type="range"] {
    height: 0;
  }

  button {
    border: none;
    background: none;
    outline: none;
    cursor: pointer;
  }

  button:disabled {
    color: #999;
    cursor: none;
  }

  button:not(:disabled):active {
    background-color: #ddd;
  }

  button:focus {
    border-color: #666;
  }

  button.button {
    border-radius: 1em;
    padding-left: 1em;
    padding-right: 1em;
    margin-right: .5em;
    background-color: #E8E8E8;
    font-family: 'helvetica-neue-lt-arabic', sans-serif;
    }
    button.button:disabled {
      border: 1px solid lightgray;
    }
    button.button:hover {
      background-color: lightgray;
    }

  h1, h2, h3, h4 {
    font-family: 'helvetica-neue-lt-arabic', serif;
    line-height: 1.2;
    color: #002238;
  }
  h2 {
    font-size: 1.5em;
  }
  .section-label {
    font-family: 'helvetica-neue-lt-arabic', sans-serif;
    text-transform: uppercase;
    color: #002238;
    font-size: 1.2em;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }
  .section-label.larger {
    font-size: 1.6em;
  }

  .bordered-image {
    position: relative;
    display: inline-block;
    border-radius: 4px;
    overflow: hidden;
  }
  .bordered-image img {
    display: block;
  }
  .bordered-image::after {
    position: absolute;
    top: 0; bottom: 0; left: 0; right: 0;
    content: '';
    opacity: 0.15;
    border: 4px solid black;
    border-radius: 4px;
  }

  /** Make sure iOS doesn't zoom in on form element focus **/
  select, 
  textarea, 
  input[type="text"], 
  input[type="password"], 
  input[type="datetime"], 
  input[type="datetime-local"], 
  input[type="date"], 
  input[type="month"], 
  input[type="time"], 
  input[type="week"], 
  input[type="number"], 
  input[type="email"], 
  input[type="url"], 
  input[type="search"], 
  input[type="tel"], 
  input[type="color"] { 
    font-size: 16px; 
  }

  .visually-hidden {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }

  .show-for-desktop {
    display: none;
  }

	main {
		margin: 0 auto;
    padding: 0 1rem;
  }
  
  .icon-repo {
    display: none;
  }
  
  @media (min-width: 1024px) {
    .wrapper {
      display: flex;
      flex-direction: row;
      max-width: 1400px;
      margin: 0 auto;
    }
    .wrapper__main {
      flex: 1 0 60%;
      padding-left: 2rem;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }
    .wrapper__sidebar {
      flex: 1 1 40%;
    }

    .show-for-desktop {
      display: inherit;
    }
    .hide-for-desktop {
      display: none;
    }
  }
</style>

<main>
  <div class="wrapper">
    <div class="wrapper__main">
      <div class="hide-for-desktop">
        <Title/>
        <Intro show={showIntro}/>
        {#await status_init then statuses}
        <Legend hasIntro="true"/>
        {/await}
        <RelationshipSelect on:relationshipPopup={handleRelationshipPopup}/>
      </div>
      <div class="show-for-desktop">
        {#await status_init then statuses}
        <Matrix bind:selectedCharacter={currentCharacter} bind:selectedRelationship={currentRelationship} on:relationshipPopup={handleRelationshipPopup} on:characterPopup={handleCharacterPopup}/>
        {/await}
      </div>
    </div>
  
    <div class="wrapper__sidebar">
      <div class="show-for-desktop">
        <Title/>
        <Intro show={showIntro}/>
        {#await status_init then statuses}
        <Legend hasIntro={showIntro} character={popupCharacter} relationship={popupRelationship} on:reset={reset}/>
        {/await}
      </div>

      <CharacterPopup character={popupCharacter}/>
      <RelationshipPopup relationship={popupRelationship}/>
    </div>
  </div>

  <div class="icon-repo">
    <svg id="icon-allies" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs/><path fill="currentColor" fill-rule="evenodd" d="M21.9 12L12 21.9 2.1 12 12 2.1l9.9 9.9zm-6.528-.001L12 8.627 8.628 12 12 15.371l3.372-3.372z"/></svg>
    <svg id="icon-adversaries" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs/><path fill="currentColor" fill-rule="evenodd" d="M20 7.66L16.34 4 12 8.339 7.66 4 4 7.66 8.339 12 4 16.34 7.66 20 12 15.66 16.34 20 20 16.34 15.66 12z"/></svg>
    <svg id="icon-complicated" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs/><path fill="currentColor" fill-rule="evenodd" d="M16.34 4L4 16.34 7.66 20 20 7.66z"/></svg>
    <svg id="icon-na" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs/><path fill="currentColor" fill-rule="evenodd" d="M20.725 9.412H3.275v5.176h17.45z"/></svg>
    <svg id="icon-favorable" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M12.488 6L5 13.709l3.465 3.494 4.03-4.149 4.046 4.15L20 13.705z" fill-rule="evenodd"/></svg>
    <svg id="icon-unfavorable" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M8.459 7L5 10.5l7.512 7.704 7.489-7.709-3.465-3.493-4.031 4.148z" fill-rule="evenodd"/></svg>
  </div>
</main>
